export const portfolioSvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-ock-foreground"
  >
    <title>Portfolio</title>
    <path
      d="M2.7125 0.875H15.875V4.625H2.7125C1.7 4.625 0.875 3.8 0.875 2.7875V2.7125C0.875 1.7 1.7 0.875 2.7125 0.875Z"
      fill="currentColor"
    />
    <path
      d="M0.875 5.875V14.5C0.875 15.95 2.05 17.125 3.5 17.125H17.125V5.875H0.875ZM13.375 12.125C12.6875 12.125 12.125 11.5625 12.125 10.875C12.125 10.1875 12.6875 9.625 13.375 9.625C14.0625 9.625 14.625 10.1875 14.625 10.875C14.625 11.5625 14.0625 12.125 13.375 12.125Z"
      fill="currentColor"
    />
  </svg>
);
